import { Box, Paper, Stack, Switch, Typography } from "@mui/material";
import React from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useThemePalette } from "common/hooks/theme_palette";
import { useTranslation } from "react-i18next";

export default function OpenRangeSwitch({
  title,
  checked,
  systemConfig,
  handleSwitchChange,
  disabled = false,
  load,
  systemConfigId,
  requesNumber,
  rangeValue,
}) {
  const { t } = useTranslation();
  const { oliveGreen, green } = useThemePalette();
  return (
    <>
      <Typography fontSize="18px" fontWeight="600" mb="19px">
        {title}
      </Typography>
      <Typography fontSize="16px" mb="19px">
        {t("orders.range_click_message", { range: systemConfig[0]?.value })}
      </Typography>
      <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} gap={{ xs: 1.5, sm: 0 }} justifyContent="space-between">
        <Paper
          elevation={0}
          sx={{
            width: { xs: "100%", sm: "178px" },
            height: "48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 8px",
            background: checked ? oliveGreen : "#9F9F9F70",
            position: "relative", // Keep the arrow and text within the container
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              width: "49px",
              height: "42px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: checked ? "white" : "#9F9F9F",
              position: "absolute",
              left: checked ? "calc(100% - 57px)" : "8px",
              transition: "left 0.3s",
              borderRadius: "8px",
              zIndex: 0,
            }}
            className="ranges"
          >
            <Box>
              <Switch
                rangeOneChecked={checked}
                onChange={handleSwitchChange}
                color="default"
                disabled={disabled}
                sx={{
                  opacity: 0,
                  position: "absolute",
                  width: "49px",
                  height: "42px",
                  top: 0,
                  left: 0,
                  right: 0,
                  "& .MuiSwitch-thumb": {
                    width: "49px",
                    height: "42px",
                    left: 0,
                    top: 0,
                  },
                  "& .MuiSwitch-track": {
                    backgroundColor: "#09c",
                  },
                }}
              />
              <Stack>
                {checked ? (
                  <ArrowBackIosNewIcon
                    sx={{
                      color: "black",
                      top: "9px",
                      left: "24%",
                      position: "absolute",
                      zIndex: -1,
                    }}
                  />
                ) : (
                  <ArrowForwardIosIcon
                    sx={{
                      color: "white",
                      top: "9px",
                      right: "28%",
                      position: "absolute",
                      zIndex: -1,
                    }}
                  />
                )}
              </Stack>
            </Box>
          </Box>
          <Typography
            sx={{
              position: "absolute",
              left: checked ? "20px" : "auto",
              right: !checked ? "20px" : "auto",
              transition: "all 0.3s",
              color: "white",
              fontSize: { xs: "11px", sm: "14px" },
              whiteSpace: "nowrap",
            }}
          >
            {checked
              ? load?.type == `range ${systemConfig && systemConfig[0]?.id}` &&
                load?.loading
                ? t("orders.sending")
                : t("orders.requests_sent")
              : t("orders.send_requests")}
          </Typography>
        </Paper>
        {requesNumber != 0 && requesNumber && (
          <Stack direction="row" alignItems="center" gap="3px">
            <Typography color={green} fontWeight="500">
              {requesNumber}
            </Typography>
            <Typography fontSize="14px">{t("orders.requests")}</Typography>
          </Stack>
        )}
      </Stack>
    </>
  );
}
